import Vue from 'vue/dist/vue.esm'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'material-design-icons/iconfont/material-icons.css'

document.addEventListener('DOMContentLoaded', () => {
    Vue.use(VueMaterial);
    project_list_vue = new Vue({
        el: '#header',
        data: {
            title: "Cell and Module Performance External Request Form"
        },
        computed: {},
        methods: {}
    });

});

